<template>
  <div>
    <HeadNav
      :title="headNavImg.title"
      :titleEn="headNavImg.profiles"
      :src="headNavImg.picture"
      news
      @clickType="getType"
    ></HeadNav>
    <!-- <div class="newNav animated fadeIn">
      <div class="newNavCont">
        <div @click="getIndex(1)" :class="{activeBg:conpanyActive}">公司新闻</div>
        <div @click="getIndex(2)" :class="{activeBg:hangActive}">行业新闻</div>
        <div @click="getIndex(3)" :class="{activeBg:technoActive}">科技卷使用流程</div>
      </div>
    </div> -->
    <div class="content pc" v-loading="loading">
      <!-- <h3>{{typeList[this.index-1]}}</h3>
      <el-divider></el-divider> -->
      <div v-for="item in list" :key="item" style="margin:45px 0; cursor: pointer;" @click="getClickNewsDetail(item.id)">
        <el-row class="animated fadeInUp">
          <el-col :span="5">
            <div class="imgAnimate">
              <img :src="item.picture" alt width="100%" height="200px" />
            </div>
          </el-col>
          <el-col :span="18" :offset="1">
            <div class="newTitle">{{item.title}}</div>
            <div class="newCont">{{item.profile}}</div>
            <div class="newTime">
              <i class="el-icon-timer"></i>
              {{getTime(item.releaseTime)}}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="mobile News" v-loading="loading">
      <!-- <ContentNav title="新闻动态" titleEn="NEWS"></ContentNav> -->
      <!-- <div @click="getNewType">
        <el-row>
          <el-col :span="24">
            <div :class="{newsType:true ,onload:this.index == 1?true:false}" data-type="1">公司新闻</div>
          </el-col>
          <el-col :span="24">
            <div :class="{newsType:true,onload:this.index == 2?true:false}" data-type="2">行业新闻</div>
          </el-col>
          <el-col :span="24">
            <div :class="{newsType:true,onload:this.index == 3?true:false}" data-type="3">科技卷使用流</div>
          </el-col>
        </el-row>
      </div> -->
      <div v-for="item in list" :key="item" style="margin:20px 0" @click="getClickNewsDetail(item.id)">
        <el-row class="animated fadeInUp">
          <el-col :span="8">
            <img :src="item.picture" alt width="100%" height="100px" />
          </el-col>
          <el-col :span="15" :offset="1">
            <h4>{{item.title}}</h4>
            <p>{{item.profile}}</p>
            <div>
              <i class="el-icon-timer"></i>
              {{getTime(item.releaseTime)}}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="text-align:center;margin:30px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="4"
        @current-change="change"
        :current-page="page"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import HeadNav from "../components/head.vue";
import { getNewsList, getTheme } from "../api/allApiRequest.js";
import ContentNav from "../components/content.vue";
export default {
  name: "News",
  data() {
    return {
      total: 0,
      list: [],
      NewList: [
        { title: "公司新闻" },
        { title: "行业新闻" },
        { title: "科技卷使用流程" }
      ],
      typeList: ["公司新闻", "行业新闻", "科技卷使用流程"],
      index: 1,
      page: 1,
      loading: true,
      headNavImg: {},
      value: 0,
      obj:'',
      conpanyActive:true,
      hangActive:false,
      technoActive:false
    };
  },
  components: {
    HeadNav,
    ContentNav
  },
  mounted() {
    this.obj = setInterval(()=>{
      // this.index = sessionStorage.getItem('type')
    },100)
    this.browserRedirect()
    this.value = location.hash.split("?")[1]
      ? location.hash.split("?")[1].split('&')[1].split("=")[1]
      : 0;
    this.getThemeHead();
    this.init();
  },
  beforeDestroy(){
      clearInterval(this.obj)
  },
  methods: {
    init(page = 1) {
      this.loading = true;
      getNewsList({ page, pageSize: 4, newsType: this.index }).then(res => {
        this.list = res.data.records;
        this.list.forEach(item=>{
          item.picture = process.env.VUE_APP_WEB_URL + item.picture
        })
        this.page = res.data.current;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    change(e) {
      this.init(e);
    },
    //发布时间处理函数
    getTime(time) {
      var time = new Date(time);
      var year = time.getFullYear();
      var month = time.getMonth()+1 < 10 ? '0'+(time.getMonth()+1) : time.getMonth()+1;
      var day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
      return `${year}--${month}--${day}`;
    },
    getNewType(e) {
      this.index = e.target.dataset.type;
      this.init();
    },
    getType(e) {
      this.index = e;
      this.init();
    },
    //主题返现
    getThemeHead() {
      getTheme({
        themeType: 2
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    },
    getClickNewsDetail(id){
      this.$router.push('/newsDetail?value=02&id='+id)
    },
    browserRedirect() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                clearInterval(this.obj)
            } 
    },
    getIndex(index){
      this.index = index;
      this.init()
      switch (index){
        case 1:
            this.conpanyActive = true;
            this.hangActive = false;
            this.technoActive = false;
          break;
        case 2:
            this.conpanyActive = false;
            this.hangActive = true;
            this.technoActive = false;
          break;
        case 3:
            this.conpanyActive = false;
            this.hangActive = false;
            this.technoActive = true;
          break;
        default:
            this.conpanyActive = true;
            this.hangActive = false;
            this.technoActive = false;
          break;
      }
    }
  }
};
</script>
<style scoped>
.newNav .activeBg{
  background: #248ECC;
  opacity: 1;
}
.newNav{
  height: 70px;
  width:100%;
  background:rgba(8,103,200,0.75);
  color:#fff;
  position: absolute;
  top:500px;
  left:0;
  font-size: 20px;
  font-weight: bold;
}
.newTitle{
  font-size:20px;
  color:#444;
  margin-top:12px;
}
.newCont{
  font-size:18px;
  color: #666;
  margin:12px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;;
}
.newTime{
  font-size:16px;
  color:#999;
}
.newNavCont{
  width:1190px;
  height: 85px;
  margin:0 auto;
}
.newNavCont div{
  float: left;
  width: 200px;
  height:70px;
  text-align: center;
  line-height: 70px;
  cursor: pointer;
}
.imgAnimate {
  width: 240px;
  height: 140px;
  overflow: hidden;
}
.imgAnimate > img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.6s;
}
.imgAnimate > img:hover {
  transform: scale(1.4);
}
.content {
  margin: 45px auto 0;
  width: 1190px;
}
.mobile {
  display: none;
}
.pc {
  display: block;
}
h3 {
  color: rgba(35, 94, 157, 1);
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
@media screen and (max-width: 750px) {
  .content {
    margin: 0;
  }
  .pc,.newNav {
    display: none;
  }
  .mobile {
    display: block;
    margin: 20px 10px 0;
  }
  h4 {
    font-size: 14px;
    margin: 3px;
    color:#000;
  }
  p {
    font-size: 12px;
    line-height: 12px;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    height: 36px;
    text-indent: 24px;
    color:#444;
  }
  .mobile div {
    font-size: 12px;
    color:#666  ;
  }
  .newsType {
    height: 60px;
    line-height: 60px;
    color: #235e9d;
    font-size: 16px !important;
    border-left: 1px solid #d8d9da;
    border-bottom: 1px solid #d8d9da;
    padding-left: 20px;
  }
  .onload {
    color: #fff;
    background-color: #235e9d;
  }
}
</style>